import groupBy from 'lodash/groupBy';
import moment from 'moment';
import { htmlToText } from 'components/form/AdvanceTextEditor';
import { saveCallHour, deleteCallHour } from 'services/ivr.service';
import actionPlanIcon from './components/digital-receptionist/img/action-plan-visit.svg';
import actionLocationIcon from './components/digital-receptionist/img/action-location.svg';
import actionJoinIcon from './components/digital-receptionist/img/action-join-group.svg';
import actionForwardTeamIcon from './components/digital-receptionist/img/action-forward-team.svg';
import actionForwardStaffIcon from './components/digital-receptionist/img/action-forward-stuff.svg';
import actionUrgentIcon from './components/digital-receptionist/img/action-urgent.svg';
import actionLeaveMsgIcon from './components/digital-receptionist/img/action-leave-msg.svg';
import workflowReminderEmailIcon from '../automated-workflows/assets/img/reminder-email-vector.svg';
import outreachServiceIcon from './components/digital-receptionist/img/outreach-service.svg';
import specialServiceIcon from './components/digital-receptionist/img/special-service.svg';
import customActionIcon from './components/digital-receptionist/img/action-custom.svg';
import { timeStrToMinutes } from './components/WeekdaySchedule';

export const ACTIONS = [
  {
    id: '2',
    title: 'Service Times and Location',
    description: 'Let callers know where and when your services are held.',
    icon: actionLocationIcon,
    template:
      'We are located at {ACCOUNT_ADDRESS_1} right here in {ACCOUNT_CITY}. Our service times are {SERVICE_TIMES}. We’ll also send you a text message with a link to our website.',

    sendSMS:
      'We can’t wait to welcome you here at {ACCOUNT_NAME}! As promised here’s the link to our site: {ACCOUNT_WEBSITE}. Reach out if you have any questions.',
  },
  {
    id: '3',
    title: 'Plan a Visit',
    description: 'Let callers Plan A Visit to your church.',
    icon: actionPlanIcon,
    template:
      'We’re excited that you’re ready to join us at {ACCOUNT_NAME}! You may have questions and we’re happy to help answer them all. First, we’re sending you a text message with a link to our website to help you plan your visit. Simply click the link in the text message and complete the short form on our site. ',
    sendSMS:
      'We’re so happy you’re going to visiting us at {ACCOUNT_NAME}. Please click this link to get your visit scheduled: {PLAN_VISIT_CONNECT_CARD}',
  },
  {
    id: '4',
    title: 'Staff Directory',
    description:
      'Callers will be given a list of staff they can be forwarded to.',
    icon: actionForwardStaffIcon,
    template:
      'Thanks, I’ll help connect you to one of our ministry leaders. To reach {Extension 1}, please press 1. To reach {Extension 2}, please press 2. Etc… To repeat this menu, press ?',
  },
  {
    id: '5',
    title: 'Team Directory',
    description:
      'Callers will be given a list of teams they can be forwarded to.',
    icon: actionForwardTeamIcon,
    template:
      'Thanks, I’ll help connect you to one of our ministry leaders. To reach {Team 1}, please press 1. To reach {Team 2}, please press 2. Etc… To repeat this menu, press ?',
  },
  {
    id: '6',
    title: 'Prayer Request',
    description: 'Let callers leave a voicemail for prayer.',
    icon: actionJoinIcon,
    template:
      'We believe in the power of prayer. Our volunteer prayer team is here to walk alongside you on your journey. Prayer requests are shared with our prayer team, who will pray for you, and will reach out if you request follow up care. After the tone, please share your prayer request.',
    voicemail: true,
  },
  {
    id: '7',
    title: 'Service Opportunities',
    description:
      'Inform callers about service opportunities and have them leave a voicemail.',
    icon: workflowReminderEmailIcon,
    template:
      'We have many service opportunities here at {ACCOUNT_NAME}. And, we’d love to help get you plugged in to a ministry that’s perfect for you. After the tone, please leave a message with your name, number and an area of ministry you are interested in serving in and we’ll reach out to help you take the next step.',
    voicemail: true,
  },
  {
    id: '8',
    title: 'Leave a Message',
    description: 'Let callers leave a message for you to call them back.',
    icon: actionLeaveMsgIcon,
    template:
      'Please leave a detailed message along with your name and call back number and one of the staff at {ACCOUNT_NAME} will return your call.',
    voicemail: true,
  },
  {
    id: '9',
    title: 'Urgent Request',
    description: 'Forward callers to care pastor.',
    icon: actionUrgentIcon,
    template:
      'If this is an emergency, please hang up and dial 911. If you have an urgent need or request, please stay on the line to speak to one of our staff.',
    forward: true,
  },
  {
    id: '12',
    title: 'Outreach Event',
    description:
      'Give callers information about your upcoming event (VBS, Fall Fest, Easter Egg Hunt, ect.)',
    icon: outreachServiceIcon,
    template:
      'Our OUTREACH EVENT is DAY, TIME, and the cost is X.\n' +
      '\n' +
      'To sign up a participant, press 1. To sign up to volunteer, press 2. To learn what donations are needed, press 3.\n',
  },
  {
    id: '11',
    title: 'Special Worship Service',
    description:
      'Give callers information about your upcoming special worship service (Christmas, Night of Worship, ect)',
    icon: specialServiceIcon,
    template:
      'Join in for a special worship service for INSERT HOLIDAY/EVENT.\nWe’ll be in-person and online on INSERT DATE, TIME.',
  },
  {
    id: '10',
    title: 'Custom Action',
    template: '',
    description: 'Create a blank action and add your own script.',
    icon: customActionIcon,
  },
];

export const WELCOME_SCRIPT = {
  template: `Hi, thanks for calling {ACCOUNT_NAME}. If you know your party’s extension, you may dial it anytime. Please listen carefully as our menu options have changed. To hear our service times and locations, please press 1. If you’re new to our community and would like to plan your visit to {ACCOUNT_NAME}, press 2. To share a prayer request with our prayer team, press 3. If you want to learn about service opportunities, please press 4. For our staff directory, press 5. And, if you’d like to visit our website, go to {ACCOUNT_WEBSITE}, or press 6, and we’ll text you a link to access it. Press '*' to repeat the menu. Thanks for calling, and have a blessed day.`,
};

export const WEEKDAYS = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];

const TIME_FORMAT_FROM = 'HH:mm:ss';
const TIME_FORMAT_TO = 'h:mm A';

const CUSTOM_AUDIO_SCRIPT = 'Custom Audio';

export const DEFAULT_PLACEHOLDERS = {
  ACCOUNT_ADDRESS_1: 'INSERT ADDRESS',
  ACCOUNT_CITY: 'INSERT CITY',
  SERVICE_TIMES: 'INSERT SERVICE TIMES',
  ACCOUNT_NAME: 'INSERT CHURCH NAME',
  PLAN_VISIT_CONNECT_CARD: 'INSERT URL',
  ACCOUNT_WEBSITE: 'INSERT URL',
};

export const replaceVariables = (template, variables) => {
  return template.replace(/\{([^}]+)\}/g, (match, key) => {
    return variables[key] || DEFAULT_PLACEHOLDERS[key] || match;
  });
};

export const createCallHourGroups = async (
  objectType,
  objectId,
  hours = {},
  existingCallHours = [],
) => {
  const days = Object.keys(hours);
  const saveItems = [];

  days.forEach((day) => {
    const values = hours[day];
    values?.forEach((value) => {
      if (value.from > -1 && value.to > -1) {
        const from = moment()
          .startOf('day')
          .set('minute', value.from)
          .format(TIME_FORMAT_FROM);
        const to = moment()
          .startOf('day')
          .set('minute', value.to)
          .format(TIME_FORMAT_FROM);

        saveItems.push({
          hash: value.hash,
          object_type: objectType,
          object_id: objectId,
          call_hour_group_day: String(WEEKDAYS.indexOf(day)),
          call_hour_group_opens_at: from,
          call_hour_group_closes_at: to,
        });
      }
    });
  });

  for (const e of existingCallHours) {
    const dow = e.call_hour_group_day;
    const day = WEEKDAYS[dow];
    const values = hours[day];
    if (!values || !values.some((i) => i.hash === e.hash)) {
      await deleteCallHour(e.hash);
    }
  }

  for (const hour of saveItems) {
    const { call_hour_group_opens_at, call_hour_group_closes_at, hash } = hour;
    let changed = true;
    if (hash) {
      const existing = existingCallHours.find((i) => i.hash === hash);
      if (existing) {
        if (
          existing.call_hour_group_opens_at === call_hour_group_opens_at &&
          existing.call_hour_group_closes_at === call_hour_group_closes_at
        ) {
          changed = false;
        }
      }
    }
    if (changed) {
      await saveCallHour(hour);
    }
  }
};

export const updateCallHourGroup = (hash, hours, timezone) => {
  // return saveCallHourGroup({
  //   hash,
  //   open_hours_group: JSON.stringify(
  //     Object.keys(hours).reduce((acc, day) => {
  //       const value = hours[day];
  //       if (value) {
  //         if (typeof value == 'string') {
  //           acc[day] = value;
  //         } else {
  //           acc[day] = toDbValues(hours[day]);
  //         }
  //       }
  //       return acc;
  //     }, {}),
  //   ),
  // });
};

export const createActions = (actions) => {
  const a = [];
  console.log(actions);
  Object.keys(actions).forEach((key) => {
    const vars = {};
    let { type, args } = actions[key];
    switch (key) {
      case 'join_group':
        vars.group_id = args;
        break;
      case 'forward':
        type = args.type;
        if (type === 'call_caller') {
          vars.caller_id = args.value;
        }
        if (type === 'call_team') {
          vars.team_id = args.value;
        }
        break;
      case 'collect_voicemail':
        vars.contact_id = Array.isArray(args) ? args.map((i) => i.value) : [];
        break;
      case 'send_sms':
        vars.message = htmlToText(args);
        break;
      default:
        break;
    }
    a.push({
      action: type,
      vars,
    });
  });
  return JSON.stringify(a);
};

export const getNextDigit = (callMenuOptions) => {
  const digits = ['1', '2', '3', '4', '5', '6', '7', '8', '9'];
  const usedDigits = callMenuOptions.map(
    (o) => o.digital_receptionist_menu_digit,
  );
  const unusedDigits = digits.filter((d) => !usedDigits.includes(d));
  return unusedDigits[0];
};

export const getCallHoursString = (callHours) => {
  const hours = Object.keys(callHours).reduce((acc, day) => {
    const hours = callHours[day];
    const dow = WEEKDAYS.indexOf(day);
    hours.forEach((h) => {
      const slot = `${h.call_hour_group_opens_at}-${h.call_hour_group_closes_at}`;
      if (!acc[slot]) {
        acc[slot] = [dow];
      } else {
        acc[slot].push(dow);
      }
    });
    return acc;
  }, {});

  const hoursString = Object.keys(hours).reduce((acc, slot) => {
    const [from, to] = slot.split('-');
    const dows = hours[slot];
    const days = dows.map((dow) => WEEKDAYS[dow]).join(', ');
    const hourString = `${moment(from, TIME_FORMAT_FROM).format(
      TIME_FORMAT_TO,
    )}-${moment(to, TIME_FORMAT_FROM).format(TIME_FORMAT_TO)}`;
    acc.push({
      days: days,
      time: hourString,
    });
    return acc;
  }, []);

  return hoursString;
};

export const hasPrimaryActionAfterSpeech = (callMenu) => {
  if (callMenu) {
    const actions = callMenu.actions_after_speech;
    if (actions && actions.length) {
      const otherActions = actions.filter((a) => a.action !== 'send_sms');
      return otherActions.length > 0;
    } else {
      return false;
    }
  }
  return false;
};

export const callHoursToMap = (callHours) => {
  const map = {};
  const grouped = groupBy(callHours, 'call_hour_group_day');
  Object.keys(grouped).forEach((key) => {
    const values = grouped[key];
    map[WEEKDAYS[key]] = values.map((i) => ({
      ...i,
      from: timeStrToMinutes(i.call_hour_group_opens_at),
      to: timeStrToMinutes(i.call_hour_group_closes_at),
    }));
  });
  return map;
};

export const isCustomAudio = (menu) => {
  return (
    menu &&
    menu.digital_receptionist_menu_say_text_to_speech === CUSTOM_AUDIO_SCRIPT
  );
};
